export default __webpack_public_path__ + "static/MediaContentOne-25950c51c37f6db2b1172e4f6a76a733.webp";